import { render, staticRenderFns } from "./SubscriptionTypeList.vue?vue&type=template&id=510b0fff"
import script from "./SubscriptionTypeList.vue?vue&type=script&lang=js"
export * from "./SubscriptionTypeList.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTypeList.vue?vue&type=style&index=0&id=510b0fff&prod&lang=scss"
import style1 from "./SubscriptionTypeList.vue?vue&type=style&index=1&id=510b0fff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports